import React from 'react';
import styled from 'styled-components';
import {device} from '../assets/device'
import merchantConfig from '../merchant/config/merchant-config';

export const ShoppingCartButtonStyles = {
	Container: styled.div`
      display: flex;
      justify-content: flex-end;
      vertical-align: baseline;
      margin: 0;
      width: 100%;
      //noinspection ALL
      @media ${device.tablet} {
        margin: 0 5px 0 0;
      }
	`,
	Button: styled.a`
      background-color: darkred;
      color: white;
      cursor: pointer;
      font-size: 1.4em;
      font-weight: 600;
      outline: none;
      text-align: center;
      text-decoration: none;
      text-transform: none;
      padding: 0 1em;
      font-family: "Open Sans", sans-serif;
      width: 6rem;
      height: 100%;
      margin: 0 0 0 1rem;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      //noinspection ALL
      @media ${device.tablet} {
        font-size: .8em;
        height: 2.8em;
        width: 100%;
        box-sizing: content-box;
        margin: 0;
      }

      &.icon-button {
        .shopping-cart__icon {
          margin: 0 .3em 0 0;
          font-size: 2em;
          //noinspection ALL
          @media ${device.tablet} {
            font-size: 1.7em;
          }
        }
      }
	`,
	ButtonText: styled.span`
      display: none;
      //noinspection ALL
      @media ${device.tablet} {
        display: inline;
      }

	`
};

const S = ShoppingCartButtonStyles;

const onlineSaleBaseUrl = merchantConfig.pcuiBaseUrl + "/shoppingcart";

const ShoppingCartButton = () => (
	<S.Container>
		<S.Button
			className="icon-button"
			href={onlineSaleBaseUrl}
			target="_top"
		>
			<i className="material-icons shopping-cart__icon">shopping_cart</i><S.ButtonText>Zum
			Warenkorb</S.ButtonText>
		</S.Button>
	</S.Container>
);

export default ShoppingCartButton;
